import type { NormalizedScores } from './types'

type ScoreDimension = keyof NormalizedScores

/**
 * Adaptive Pareto dominance using user-relevant score dimensions.
 *
 * All scores are normalized [0,1] with higher = better. Flight B dominates A
 * if B is >= A on every selected dimension and strictly > on at least one.
 */
export function computeAdaptiveParetoFlags (
    flightScores: Record<string, Pick<NormalizedScores, ScoreDimension>>,
    flightIds: string[],
    dimensions: ScoreDimension[]
): Record<string, boolean> {
    const flags: Record<string, boolean> = {}
    for (const id of flightIds) flags[id] = true

    for (let i = 0; i < flightIds.length; i++) {
        if (!flags[flightIds[i]]) continue
        for (let j = 0; j < flightIds.length; j++) {
            if (i === j) continue
            const a = flightIds[i]
            const b = flightIds[j]
            const scoresA = flightScores[a]
            const scoresB = flightScores[b]

            let notWorseInAll = true
            let strictlyBetterInOne = false
            for (const dim of dimensions) {
                if (scoresB[dim] < scoresA[dim]) { notWorseInAll = false; break }
                if (scoresB[dim] > scoresA[dim]) strictlyBetterInOne = true
            }

            if (notWorseInAll && strictlyBetterInOne) {
                flags[a] = false
                break
            }
        }
    }

    return flags
}
